import { Moment } from 'moment'

import { ConfigFilterItem, ConfigItem, DefaultFile } from 'Core/interfaces'

export enum PurchaseOrderFields {
	id = 'id',
	purchaseOrderNumber = 'purchaseOrderNumber',
	billingLocation = 'billingLocation',
	serviceSites = 'serviceSites',
	amount = 'amount',
	balance = 'balance',
	effectiveStartDate = 'effectiveStartDate',
	effectiveEndDate = 'effectiveEndDate',
	status = 'status',
	currencyCode = 'currencyCode'
}

export enum PurchaseOrderStatus {
	Pending = 'Pending',
	Approved = 'Approved',
	Rejected = 'Rejected',
	Expired = 'Expired'
}

export enum PurchaseOrderFilterFields {
	serviceSiteId = 'serviceSiteId',
	statusId = 'statusId'
}

export enum PurchaseOrderMainSearchFields {
	searchByPOId = 'searchByPOId',
	searchByPONumber = 'searchByPONumber'
}

export declare namespace PurchaseOrder {
	interface Basic {
		[PurchaseOrderFields.id]: number
		[PurchaseOrderFields.purchaseOrderNumber]: BasicString
		[PurchaseOrderFields.billingLocation]: Nullable<Entity>
		[PurchaseOrderFields.serviceSites]: Entity[]
		[PurchaseOrderFields.amount]: number
		[PurchaseOrderFields.balance]: number
		[PurchaseOrderFields.effectiveStartDate]: BasicString
		[PurchaseOrderFields.effectiveEndDate]: BasicString
		[PurchaseOrderFields.status]: string
		[PurchaseOrderFields.currencyCode]: string
	}
	interface Detailed {
		id: number
		customerId: number
		purchaseOrderNumber: string
		amountLeft: number
		lessTotalInvoiceAmount: number
		lessModifiedExtendedPrice: number
		effectiveStartDate: string
		effectiveEndDate: BasicString
		status: BasicString
		comments: BasicString
		serviceSites: Entity[]
		fileName: string
		documentName: string
		historyFiles: Entity[]
	}

	interface History {
		customerInvoiceId: number
		totalInvoiceAmount: number
		totalModifiedExtendedPrice: BasicNumber
		balanceLessTotalExtendedPrice: number
		balanceLessModifiedExtendedPrice: BasicNumber
		invoiceCreateDate: BasicString
		currency: string
	}

	interface Form {
		customerId: LabelValue<number> | null
		serviceSitesIds: LabelValue<number>[]
		purchaseOrderNumber: string | null
		amount: number | null
		currency: BasicString
		effectiveStartDate: Moment | null
		effectiveEndDate: Moment | null
		file: DefaultFile | null
		fileName: BasicString
	}
	namespace Request {
		interface Generic {
			customerId: number
			serviceSitesIds: number[]
			purchaseOrderNumber: string
			amount: number
			effectiveStartDate: string
			effectiveEndDate: BasicString
			file: File
		}
		interface WithHistory {
			amount: number
			effectiveStartDate: string
			effectiveEndDate: BasicString
			file: File
		}
	}
	namespace Filter {
		interface Config {
			[PurchaseOrderFilterFields.serviceSiteId]: ConfigFilterItem<string, string>
			[PurchaseOrderFilterFields.statusId]: ConfigFilterItem<string, string>
		}
	}

	namespace Search {
		interface Config {
			[PurchaseOrderMainSearchFields.searchByPOId]: ConfigItem<PurchaseOrderMainSearchFields>
			[PurchaseOrderMainSearchFields.searchByPONumber]: ConfigItem<PurchaseOrderMainSearchFields>
		}

		interface Result {
			[PurchaseOrderMainSearchFields.searchByPOId]: Entity[]
			[PurchaseOrderMainSearchFields.searchByPONumber]: Entity[]
		}
	}

	interface BillingLocationAddress {
		customerId: number
		customerName: string
		addressLine1: BasicString
		addressLine2: BasicString
		city: BasicString
		state: BasicString
		zip: BasicString
		customerCurrencyCode: BasicString
	}
}
